export default __webpack_public_path__ + "static/media/banner.2473fcc2.png";